// navigation.js
import { useNavigate as useRRNavigate, useLocation as useRRLocation } from "react-router-dom"

export function useNavigate() {
  const navigate = useRRNavigate()
  return (path, options = {}) => {
    navigate(path, { state: options.state })
  }
}

export function useLocation() {
  const location = useRRLocation()
  return {
    pathname: location.pathname,
    search: location.search,
    state: location.state,
  }
}
